import { Spin, Table } from "antd";
import { useRef } from "react";

interface DownloadTableComponentProps {
  columns: any[];
  dataSource: any[];
  loading: boolean;
  tableKey: string | number;
}

function DownloadTableComponent({ columns, dataSource, loading, tableKey }: DownloadTableComponentProps) {
  const tableContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={tableContainerRef}
      id="table"
      className="table"
      style={{ overflowY: loading ? "hidden" : "auto" }}>
      <Table
        className="table"
        rowKey={(record) => record.id}
        key={tableKey}
        bordered
        rowClassName={(record, index) => `${index % 2 === 0 ? "table-row-light" : "table-row-dark"} `}
        size="small"
        loading={loading}
        showSorterTooltip={false}
        dataSource={dataSource}
        pagination={false}
        columns={columns}
        scroll={{ x: "max-content" }}
        footer={() =>
          loading ? (
            <div style={{ textAlign: "center", padding: "10px" }}>
              <Spin
                size="large"
                tip="Loading..."
              />
            </div>
          ) : null
        }
      />
    </div>
  );
}

export default DownloadTableComponent;
